import { ErrorMessage, Text } from '@wyz/ui';
import { isNil } from 'lodash-es';
import { NoActions } from '~/common/components';
import { Trans } from '~/common/context';
import { usePurchaseContext } from '~/purchase/context';

export default function RequiredCustomerWarning() {
  const { state } = usePurchaseContext();

  return (
    <>
      <ErrorMessage
        message={
          <Text heading='normal' color='danger'>
            <Trans
              i18nKey={
                isNil(state.targetCustomer)
                  ? 'app.purchase.search_page.errors.required_customer.alert'
                  : 'app.purchase.search_page.errors.customer_not_eligible'
              }
              components={[<strong key={0} />]}
            />
          </Text>
        }
      />
      <div>
        <NoActions
          title={
            <Trans i18nKey='app.purchase.search_page.errors.required_customer.title' />
          }
          subtitle={
            <Trans
              i18nKey={
                isNil(state.targetCustomer)
                  ? 'app.purchase.search_page.errors.required_customer.subtitle'
                  : 'app.purchase.search_page.errors.customer_not_eligible'
              }
            />
          }
        />
      </div>
    </>
  );
}
